<form [formGroup]="cargueForm" class="card">
    <div class="card-header">
      <b>Carga Masiva de actualización de Cobradores</b>
    </div>
    <div class="card-body " style="margin-right: -5px; display: flex; justify-content: space-between; gap: 10px;">
      <div class="col-md-6 col-12">
        <button type="button" style="margin-bottom:21.5px; padding:0px 15px; " mat-button class="secondary  w-100" (click)="inputFile.click()">
          Selecionar archivo
        </button>
        <input type="file" accept=".csv" (change)="onSelectFile(inputFile)" #inputFile  hidden/>
      </div>
      <div class="col-md-6 col-12">
        <div class="d-inline-flex justify-content-between">
          <button [disabled]="cargueForm.invalid && !isFileLoaded" (click)="onSumbit()" mat-button class="primary mb-3 mr-1">
            Subir Archivo
          </button>
          <button [disabled]="cargueForm.invalid && !isFileProce" (click)="onProcess()" mat-button class="primary mb-3 btn-sm ml-1">
            Procesar Datos
          </button>
        </div>
      </div>
    </div>
    <div class="card-footer gap-1" >
    </div>
  </form>
  